"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BooleanKeyPipe = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
let BooleanKeyPipe = class BooleanKeyPipe {
    constructor() {
    }
    transform(value, term, key) {
        if (value) {
            if (typeof term === 'boolean') {
                if (key) {
                    return value.filter(item => {
                        return (item[key] == term);
                    });
                }
                else {
                    return value;
                }
            }
            else {
                return value;
            }
        }
    }
};
exports.BooleanKeyPipe = BooleanKeyPipe;
exports.BooleanKeyPipe = BooleanKeyPipe = __decorate([
    (0, core_1.Pipe)({ name: 'booleanKey', pure: false }),
    __metadata("design:paramtypes", [])
], BooleanKeyPipe);
//# sourceMappingURL=boolean-key.pipe.js.map